"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const pulse_components_1 = require("@pcs/pulse-components");
const react_redux_1 = require("react-redux");
const stage_review_decision_override_types_1 = require("./stage-review-decision-override-types");
const index_1 = __importDefault(require("./StageReviewDecisionOverrideMenuList/index"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const StageReviewDecisionOverride = (props) => {
    const { selected, decisionStatuses, handleDecisionChange, decisionChangeEnabled, } = props;
    const { blockRound, availableReviewZiflow } = (0, react_redux_1.useSelector)((state) => state.review);
    const canNotMadeDecision = (0, react_1.useMemo)(() => {
        if (!availableReviewZiflow) {
            return true;
        }
        if (blockRound) {
            return blockRound;
        }
        return !decisionChangeEnabled;
    }, [blockRound, decisionChangeEnabled, availableReviewZiflow]);
    const [options, setOptions] = (0, react_1.useState)([]);
    const [value, setValue] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (decisionStatuses.length > 0) {
            const listOptions = decisionStatuses.map((item) => {
                const defaultOption = {
                    ...item,
                    class: 'fa-clock',
                    icon: 'fal fa-check-circle',
                    statusIcon: 'fal fa-clock',
                };
                switch (item.value) {
                    case stage_review_decision_override_types_1.DecisionStatus.inProgress:
                        return {
                            ...defaultOption,
                            icon: 'fal fa-hourglass-half',
                        };
                    case stage_review_decision_override_types_1.DecisionStatus.approvedWithChanged:
                        return {
                            ...defaultOption,
                            class: 'fa-check-circle',
                            statusIcon: 'fal fa-check-circle',
                        };
                    case stage_review_decision_override_types_1.DecisionStatus.changesRequired:
                        return {
                            ...defaultOption,
                            icon: 'fal fa-repeat',
                        };
                    case stage_review_decision_override_types_1.DecisionStatus.notRelevant:
                        return {
                            ...defaultOption,
                            icon: 'fal fa-circle',
                        };
                    default:
                        return defaultOption;
                }
            });
            setOptions(listOptions);
            if (selected) {
                const selectedValue = listOptions.find((item) => item.value === selected) || listOptions[0];
                setValue(selectedValue);
            }
        }
    }, [selected, decisionStatuses]);
    const handleValueChange = async (option) => {
        setValue(option);
        handleDecisionChange(option);
    };
    const customComponent = {
        MenuList: () => (react_1.default.createElement(index_1.default, { dataOptions: options, onChangeOption: handleValueChange })),
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default.customReviewRoot },
        (value === null || value === void 0 ? void 0 : value.statusIcon) && (react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default.customSelectIcon, canNotMadeDecision && styles_modules_less_1.default['customSelectIcon--disable'], styles_modules_less_1.default[value.class], value.statusIcon) })),
        react_1.default.createElement(pulse_components_1.PulseSelectBase, { classes: {
                root: (0, clsx_1.default)(styles_modules_less_1.default.customSelectRoot, canNotMadeDecision && styles_modules_less_1.default['customSelectRoot--disable']),
                menu: {
                    menuCtn: styles_modules_less_1.default.customMenuCtn,
                },
                select: styles_modules_less_1.default.customSelect,
                selectContainer: styles_modules_less_1.default.customSelectContainer,
                placeholder: styles_modules_less_1.default.customPlaceholder,
            }, components: customComponent, dataStructure: null, hideMenuOnValueChange: true, isClearable: false, isMulti: false, isSearchable: false, TippyProps: {
                appendTo: document.body,
                arrow: true,
                offset: [0, 5],
                placement: 'bottom-end',
            }, value: value, isDisabled: canNotMadeDecision })));
};
exports.default = StageReviewDecisionOverride;
